import * as types from '../types'

/**
 * misc数据
 * @type {Object}
 * card: 充值卡数据
 */
const state = {
  card: {
    thumb: 'card/card1.jpg',
    title: '原味充值卡',
    desc: '食物原本的味道怎能一人独享，独乐乐不如众乐乐，人生分享而加倍快乐，因分享而更有情趣……',
    content: [{
        id: 1,
        type: 3,
        content: 'card/card2.jpg'
      },
      {
        id: 2,
        type: 2,
        content: '您可以将这份真情实意亲自赠与挚爱的亲朋，也可以委托我们将这份感动传达给您的至交好友。'
      },
      {
        id: 3,
        type: 2,
        content: '这份礼物将会由一个白色的信封承载，上面写着“原味生活、吃在当季、吃在当地、吃在当天”。打开内部折页，你送给对方的这张充值卡被安放在这里。你在原味生活上看到过的优质食材也罗列在目。'
      },
      {
        id: 4,
        type: 3,
        content: 'card/card3.jpg'
      },
      {
        id: 5,
        type: 3,
        content: 'card/card4.jpg'
      },
      {
        id: 6,
        type: 2,
        content: '原味还把我们所坚持的“可持续化农业方式”、“吃在当季、吃在当地、吃在当天”、“构建经过原味筛选、孵化、培养、监督、检测的实名制本地农户和消费者之间长久信任关系”等理念简述与此，收到卡片的人，会立刻明白你这份礼物的分量与意义：“原味，我不仅仅是收到了一张购物充值卡，更重要的，是我一直在寻找的——安全新鲜的食物、保留了食材原本味道的食物，此刻，你帮我找到了”'
      },
      {
        id: 7,
        type: 3,
        content: 'card/card5.jpg'
      },
      {
        id: 8,
        type: 2,
        content: '接受你这份心意的人，在原味生活使用这张充值卡「购物—付款」的流程会十分简明、便捷。'
      },
      {
        id: 9,
        type: 3,
        content: 'card/card6.jpg'
      },
      {
        id: 10,
        type: 2,
        content: '与一般购物流程相比，用此卡充值之后，就可在结算时直接用账户余额付款，免去跳转支付方式的步骤，更加方便。'
      },
      {
        id: 11,
        type: 2,
        content: '所以，在你把这张好看又好用的充值卡送给他人的同时，也可以考虑，为自己也买上一份。毕竟，你怎样爱他人，也应该怎样爱自己。'
      }
    ]
  }
}

const getters = {

}

const mutations = {}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/other.js